/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * My API
 * OpenAPI spec version: 1.0.0
 */

export type PlacementSplitInputOwnerType = typeof PlacementSplitInputOwnerType[keyof typeof PlacementSplitInputOwnerType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlacementSplitInputOwnerType = {
  recruiter: 'recruiter',
  referrer: 'referrer',
  agency: 'agency',
  external: 'external',
} as const;
